// import { Button, TextField, Typography } from "@material-ui/core";
// import { useState } from "react";

// const Calculator = () => {
 
//     const [revenue, setRevenue] = useState()
//     const [income, setIncome] = useState({
//         axmad: 0,
//         group: 0
//     })

//     console.log(revenue)

//     const calculator = () => {
//         let axmad = (revenue / 100) * 27
//         let group = (revenue / 100) * 36.5
//         setIncome({
//             axmad: axmad,
//             group: group
//         })
//     }

//     const searchStyle = { width: "150px", height: "40px",
//     padding: "12px", fontSize: "16px", borderRadius: "8px",
//     background: "white", border: "1px solid black",
//   }

//   return (
//     <div
//       style={{
//         height: "100%",
//         width: "95%",
//         margin: "0px auto",
//         display: "flex",
//         gap: "32px",
//         flexDirection: "column",
//       }}
//     >
//       <Typography style={{ fontWeight: "600", fontSize: "25px" }}>
//         {" "}
//         Revenue Calculator{" "}
//       </Typography>

//      <div style = {{display: "flex", flexDirection: "row", gap: "15px"}}>

//       <input
//       type="number"
//       placeholder="Enter Revenue"
//       style={searchStyle}
//       onChange={(e) => setRevenue(e.target.value)}
//     />

    
// <Button
//           style={{
//             width: "135px",
//             fontSize: "16px",
//             background: "#19274B",
//             color: "white",
//           }}
//           type="submit"
//           variant="contained"
//           onClick = {calculator}
//         >
//           Calculate
//         </Button>
//      </div> 

//       <Team income = {income}/>
//     </div>
//   );
// };


// const Team = (props) => {
// console.log(props.income)

//   const data = [
//     { name: "Axmad Maxamad", value: props.income.axmad },
//     { name: "Cabdimajid Macalin", value: props.income.group },
//     { name: "Cabdullahi Axmad", value: props.income.group },
//   ];
//   return (
//     <div style={{ width: "30%" }}>
//       {data.map((d) => {
//         return (
//           <div
//             style={{
//               display: "flex",
//               justifyContent: "space-between",
//               padding: "3px",
//             }}
//           >
//             <Typography
//               style={{
//                 fontSize: "18px",
//                 fontWeight: "bold",
//               }}
//             >
//               {" "}
//               {d.name}:
//             </Typography>
            
//             <Typography
//               style={{
//                 fontSize: "18px",
//               }}
//             >
//               {" "}
//               {d.value}
//             </Typography>
//           </div>
//         );
//       })}
//     </div>
//   );
// };

// export default Calculator;

import axios from "axios"
import { constants } from "../Helpers/constantsFile"
import { useState } from "react"
import { Business } from "@material-ui/icons"
import { useSelector } from "react-redux"
import moment from "moment"
import { Typography } from "@material-ui/core"


const Calculator = () => {

  const [customers, setCustomers] = useState([])
  const [vendors, setVendors] = useState([])
  const [transactions, setTransactions] = useState([])
  const business = `123`
  const userId = `user-id`
  const myToken = useSelector(state => state.token.token)
  const getCustomers = async () => {

    const response = await axios
    .get(`${constants.baseUrl}/customers/get-customers-by-user/user-id`, {
      headers: {
        'authorization': myToken
       },
    }).then((res)=>{
        // setData(res.data.data[name])
        alert("Success")
      //   setCustomers(res.data?.data?.customers)
      // setVendors(res.data?.data?.vendors)
      console.log(res?.data)
      setCustomers(res?.data?.data?.customers)
    })
    .catch((err) => {
      alert(err.response?.data?.message);
    });
  }

  const filteredTransactions = transactions?.filter(transaction => 
    moment(transaction.updated_at).format('YYYY-MM-DD') === '2024-09-10'  // Format the date to match 'YYYY-MM-DD'
  );
  
  console.log(filteredTransactions);

 const closeCustomerStatement = async (customer) => {
  if (customer?.type === "deynle") {
    const response = await axios
      .post(
        `${constants.baseUrl}/customers/clear-customer-book`,
        { userId: userId, customerId: customer?._id, password:"12345" },
        {
          headers: {
            authorization: myToken,
          },
        }
      )
      .then((res) => {
        //   setCustomers(res.data?.data?.customers)
        //   setVendors(res.data?.data?.vendors)
        console.log(res?.data);
      })
      .catch((err) => {
        alert(err.response?.data?.message);
      });
  } else {
    console.log("Customer is not deynle, skipping request.");
  }
};



  const loopAndUpload = async (element) => {
    if (element.type ==  "deynle")
    try {
      const customerResponse = await axios.post(
        `${constants.baseUrl}/customers`,
        {
          name: element?.name,
          user: userId,
          phone: element?.phone
        },
        {
          headers: {
            "authorization": myToken
             }
        }
      );
  
      console.log('Customer Response:', customerResponse);
  
      // const transactionResponse = await axios.post(
      //   `https://booktire-api.onrender.com/api/client/v1/transactions`,
      //   {
      //     business: business,
      //     customer: customerResponse.data?.data?.customer?._id,
      //     description: "Total",
      //     debit: element?.balance,
      //     date: "2024/07/27"
      //   },
      //   {
      //     headers: {
      //       "authorization": myToken
      //     }
      //   }
      // );
  
      // console.log('Transaction Response:', transactionResponse);
    } catch (error) {
      console.error('Error:', error.response ? error.response.data : error.message);
    }
  };
  const loopAndUploadVendors = async (element) => {
    try {
      const customerResponse = await axios.post(
        `https://booktire-api.onrender.com/api/client/v1/vendors`,
        {
          name: element?.name,
          business: business,
          phone: element?.phone
        },
        {
          headers: {
            "authorization": myToken
          }
        }
      );
  
      console.log('Customer Response:', customerResponse);
  
      // const transactionResponse = await axios.post(
      //   `https://booktire-api.onrender.com/api/client/v1/transactions`,
      //   {
      //     business: business,
      //     vendor: customerResponse.data?.data?.vendor?._id,
      //     description: "Total",
      //     debit: element?.balance,
      //     date: "2024/07/27"
      //   },
      //   {
      //     headers: {
      //       "authorization": myToken
      //     }
      //   }
      // );
  
      // console.log('Transaction Response:', transactionResponse);
    } catch (error) {
      console.error('Error:', error?.response ? error?.response?.data : error?.message);
    }
  };
  
      const uploadHandler = async () =>  {

         customers?.forEach(loopAndUpload)
        //  customers?.forEach(closeCustomerStatement)
         
      }
  
      const uploadVendors = async () =>  {

         vendors?.forEach(loopAndUploadVendors)
         
      }


  return (
    <div>
      this is the main event
      <button onClick={()=> getCustomers()}>
        Get customers
      </button>

      <button onClick={()=> uploadHandler()}>
        store customers
      </button>
      <button onClick={()=> uploadVendors()}>
        store Vendors
      </button>

      {filteredTransactions?.map(tran => {
        return <div style = {{display: "flex", flexDirection: "row", gap: "20px"}}>
          <Typography>{tran?.description}</Typography>
          <Typography>{moment(tran?.created_at).format("YYYY-MM-DD:hh:mm:ss")}</Typography>
          <Typography>{moment(tran?.updated_at).format("YYYY-MM-DD:hh:mm:ss")}</Typography>
          <Typography>${tran?.credit}</Typography>
          </div>
      })}
      </div>
  )
}

export default Calculator









// import { Button } from "@material-ui/core";
// import axios from "axios";
// import React, {useState} from "react";
// import * as XLSX from 'xlsx'
// import { constants } from "../Helpers/constantsFile";
// import { DateRangeRounded, Description } from "@material-ui/icons";
// import { useSelector } from "react-redux";

// const parentDivStyle = { display: "flex", alignItems: "center",
// justifyContent: "space-between",  gap: "0px", padding: "20px",
// background: "white", width: "95%", margin: "auto",
// marginTop: "20px", borderRadius: "8px 8px 0px 0px",
// flexDirection: "column"
// }

// const ImportProducts = () => {
//     const [excelFile, setExcelFile]=useState(null);
//     const [excelFileError, setExcelFileError]=useState(null);  
//     const [excelData, setExcelData]=useState(null);
//     const fileType=["application/vnd.openxmlformats-officedocument.spreadsheetml.sheet"];
//     let cashCustomers = []
//     const token = useSelector(state => state.token.token)


//     const handleSubmit=(e)=>{
//         e.preventDefault()
//         console.log("It is called")
//         if(excelFile!==null){
//           console.log("in if again")
//           try {
//             const workbook = XLSX.read(excelFile, { type: 'buffer' });
//             const worksheetName = workbook.SheetNames[0];
//             const worksheet=workbook.Sheets[worksheetName];
//             const data = XLSX.utils.sheet_to_json(worksheet);
//             const sheetName = 'Sheet1'; // Or use workbook.SheetNames[1] to target 'Sheet1' dynamically
//             console.log(data)
//             if (workbook.SheetNames.includes(sheetName)) {
//               const worksheet = workbook.Sheets[sheetName];
//               const data = XLSX.utils.sheet_to_json(worksheet);
//               setExcelData(data);
//             }
//           } catch (error) {
//             console.error('Error reading Excel file:', error);
//             setExcelData(null); // Set data to null on error
//           }
//         }
//         else{
//           console.log("file is null")
//           setExcelData(null);
//         }
//       }    
      
//     const handleFile = (e)=>{
//         let selectedFile = e.target.files[0];
//         console.log(selectedFile)
//         if(selectedFile){
//           // console.log(selectedFile.type);
//           if(selectedFile&&fileType.includes(selectedFile.type)){
//             let reader = new FileReader();
//             reader.readAsArrayBuffer(selectedFile);
//             reader.onload=(e)=>{
//               console.log(e)
//               setExcelFileError(null);
//               setExcelFile(e.target.result);
//             } 
            
//         }
//         else{
//             setExcelFileError('Please select only excel file types');
//             setExcelFile(null);
//         }
//     }
//     else{
//         console.log('plz select your file');
//     }
   
//       }

//       excelData?.map((data, index) => {
//         if (true)  {
//         // if (!data["Name"]) return
//         // if (data["__EMPTY_1"] == "Customer") return
//         cashCustomers.push({
//         user: "668907950393c38cfedc2e07",
//         name: data["Name"],
//         phone: data["Phone"]?.toString() || "0000000000",
//         balance: data["Balance"],
//         district: data.Address || "empty",
//         type: "deynle"
//         })
//       }
//       })

//       const loopAndUpload = async (element) => {
//         const response = await axios.post(`${constants.baseUrl}/customers`,
//        element,
//         {
//           headers: {
//             "authorization": token
//           }
//         })
//         console.log(response)
//         const response2 = await axios.post(`${constants.baseUrl}/transactions`,
//         { user: "668907950393c38cfedc2e07",
//         customer: response.data?.data?.customer?._id,
//         description: "Total",
//         debit: element.balance,
//         date: "2024/02/6"},
//         {
//           headers: {
//             "authorization": token
//           }
//         })

//         console.log(response2)
//       }


//       const uploadHandler = async () =>  {

//          cashCustomers?.forEach(loopAndUpload)
         
//       }

//       console.log(excelData)

//       const imageUrl = 'https://firebasestorage.googleapis.com/v0/b/deentire-application.appspot.com/o/LOGO%2Fcaalami.jpeg?alt=media&token=c98a3e2c-2b36-499e-9ba0-bae60a5a9832';
     

//     return (

//         <div style={parentDivStyle}>

//       <form autoComplete="off"
//         onSubmit={handleSubmit}>
//           <label><h5>Upload Excel file</h5></label>
//           <br></br>
//           <input type='file' className='form-control'
//           onChange={handleFile} required></input>                  
//           {excelFileError&&<div className='text-danger'
//           style={{marginTop:5+'px'}}>{excelFileError}</div>}
//           <button type='submit' className='btn btn-success'
//           style={{marginTop:5+'px'}}>Submit</button>
//         </form>

//         {excelData?.map(data => {
//           // if (!data["Name"]) return
//            return <div style={{display: "flex", gap: "20px",
//             width: "40%", justifyContent: "space-between"}}>
//                 <p> {data['Name']}</p>
//                 <p> {data['PHONE']}</p>
//                 <p> {data['Address']}</p>
//                 <p> {data["Balance"]}</p>
             
//             </div>
// })}

//         <Button onClick = {uploadHandler}
//         variant = "contained" style = {{background: "blue"}}>
//             Upload
//         </Button>

//         {/* <div style={{ width: '100px', height: '300px', overflow: 'hidden' }}>
//       <h2>Image from URL</h2>
//       <img
//         src={imageUrl}
//         alt="Your Image"
//         style={{ width: '100%', height: '100%', objectFit: 'cover' }}
//       />
//     </div> */}

//         </div>


//     )
// }

// export default ImportProducts
